import { render, staticRenderFns } from "./CurrentPlayer.vue?vue&type=template&id=400f7db8&scoped=true&"
import script from "./CurrentPlayer.vue?vue&type=script&lang=js&"
export * from "./CurrentPlayer.vue?vue&type=script&lang=js&"
import style0 from "./CurrentPlayer.vue?vue&type=style&index=0&id=400f7db8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400f7db8",
  null
  
)

export default component.exports